import * as React from "react";
import * as ReactRedux from "react-redux";

import {selectors, actions, AuthedUser} from "../reducers/lab";

import {selectors as userSelectors} from "../reducers/current_user";

import Popover, {PopoverAnimationVertical} from "material-ui/Popover";
import {Menu, MenuItem} from "material-ui/Menu";
import Divider from "material-ui/Divider";
import CircularProgress from "material-ui/CircularProgress";

import UserIcon from "./Lab/UserSwitcherIcon";
import CloseIcon from "material-ui/svg-icons/navigation/close";

interface LabUserSwitcherProps {
	users: { [id: string]: AuthedUser };
	user: AuthedUser;
	currentUserId: string;
	isRefreshingToken: boolean;

	changeAuthedUser(User: AuthedUser): any;
	removeAuthedUser(User: AuthedUser): any;
}

class LabUserSwitcher extends React.Component<LabUserSwitcherProps> {
	state = {
		isPopoverOpen: false,
	};

	private labelElement: HTMLElement;

	togglePopover() {
		this.setState({isPopoverOpen: !this.state.isPopoverOpen});
	}

	changeAuthedUser(user: AuthedUser) {
		this.setState({isPopoverOpen: false}); // close Popover and Slideout
		this.props.changeAuthedUser(user);
	}

	removeAuthedUser(e, user: AuthedUser) {
		e.stopPropagation();
		this.setState({isPopoverOpen: false}); // close Popover
		this.props.removeAuthedUser(user);
	}

	render() {
		const {user, users, currentUserId, isRefreshingToken} = this.props;
		const {isPopoverOpen} = this.state;
		const usersLabel = user ? (
			user.firstName || user.lastName ? `${user.firstName} ${user.lastName}` : user.id) : "Current User";
		let usersArray = Object.keys(users).map(id => users[id]); // convert users mapping into array
		usersArray = usersArray.filter((a) => a != null);
		usersArray.forEach(user => {
			console.log(user);
		});
		usersArray.sort((a, b) => (a.firstName||"").localeCompare(b.firstName||"")); // sort users array by firstName

		return (
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					fontSize: "0.75rem",
					fontWeight: 700,
					color: "#414042",
				}}
			>
				{!isRefreshingToken && (
					<div
						ref={el => (this.labelElement = el)}
						onClick={this.togglePopover.bind(this)}
						style={{
							display: "inline-flex",
							alignContent: "center",
							cursor: "pointer",
						}}
					>
						<UserIcon
							style={{
								marginRight: "0.75rem",
							}}
						/>

						<p
							style={{
								display: "inline-block",
								margin: 0,
								lineHeight: "22px",
							}}
						>
							AUTHENTICATED AS: {usersLabel}
						</p>
					</div>
				)}

				{isRefreshingToken && (
					<div
						style={{
							display: "inline-flex",
							alignContent: "center",
						}}
					>
						<CircularProgress
							size={22}
							color="black"
							style={{
								marginRight: "0.75rem",
							}}
						/>

						<p
							style={{
								margin: 0,
								display: "inline-block",
							}}
						>
							ACCESS TOKEN IS REFRESHING..
						</p>
					</div>
				)}

				<Popover
					open={isPopoverOpen}
					anchorEl={this.labelElement}
					anchorOrigin={{
						horizontal: "left",
						vertical: "bottom",
					}}
					targetOrigin={{
						horizontal: "left",
						vertical: "top",
					}}
					onRequestClose={this.togglePopover.bind(this)}
					style={{
						marginTop: 7,
					}}
					animation={PopoverAnimationVertical}
				>
					<Menu style={{ minWidth: 175 }}>
						{usersArray.map(u => {
							// Label should be firstName lastName, or show the ID if they have no name set
							const label = u.firstName || u.lastName ? `${u.firstName} ${u.lastName}` : u.id;

							return (
								<MenuItem
									key={u.id}
									primaryText={label}
									rightIcon={
										currentUserId !== u.id ? (
											<CloseIcon
												hoverColor="red"
												style={{
													width: "38px",
													height: "48px",
													margin: 0,
													padding: "17px 12px",
												}}
												onClick={e => this.removeAuthedUser(e, u)}
											/>
										) : null
									}
									onClick={() => this.changeAuthedUser(u)}
								/>
							);
						})}

						<Divider />

						<p
							style={{
								margin: 0,
								color: "rgba(0, 0, 0, 0.6)",
								maxWidth: "280px",
								padding: "0 1rem",
							}}
						>
							Use the Login API request to add a User to the list
						</p>
					</Menu>
				</Popover>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	currentUserId: userSelectors.selectCurrentUserId(state),
	user: selectors.selectAuthedUser(state),
	users: selectors.selectAuthedUsers(state),
	isRefreshingToken: selectors.selectIsRefreshingToken(state),
});

const mapDispatchToProps = {
	changeAuthedUser: actions.changeAuthedUser,
	removeAuthedUser: actions.removeAuthedUser,
};

// note: as any is a cheap hack... not sure why the "style" prop is causing problems
export default ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(LabUserSwitcher);



// WEBPACK FOOTER //
// ./src/components/LabUserSwitcher.tsx